// import axios from "axios";
// import { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import "./Login.css"; // Import CSS

// const Login = () => {
//   const navigate = useNavigate();
//   const [passwordVisible, setPasswordVisible] = useState(false);
//   const [loginData, setLoginData] = useState({
//     username: "",
//     password: "",
//   });
//   const [loginId, setLoginId] = useState();

//   const [otp, setOtp] = useState("");
//   const [isOtpVisible, setIsOtpVisible] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   const handleEye = () => {
//     setPasswordVisible(!passwordVisible);
//     const eyeIcon = document.querySelector("#eyeIcon");
//     eyeIcon.classList.toggle("fa-eye");
//   };

//   const handleChange = (e) => {
//     setLoginData({
//       ...loginData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleOtpChange = (e) => {
//     setOtp(e.target.value);
//   };

//   const handleLogin = (e) => {
//     e.preventDefault();

//     axios
//       .post(`${API_BASE_URL}/admin/login`, loginData)
//       .then((response) => {
//         setLoginId(response.data.id);
//         setIsOtpVisible(true);
//       })
//       .catch((error) => {
//         console.log("Error logging in:", error.response.data);
//       });
//   };

//   const handleOtpVerification = () => {
//     axios
//       .post(
//         `${API_BASE_URL}/admin/verify-otp/${loginId}`,
//         { otp }
//       )
//       .then((response) => {
//         setIsOtpVisible(false);
//         setIsLoggedIn(true);
//         localStorage.setItem("token", response.data.token);
//         navigate("/");
//         window.location.reload("/");
//       })
//       .catch((error) => {
//         console.log("Error verifying OTP:", error.response.data);
//       });
//   };

//   useEffect(() => {
//     const loginWrapper = document.querySelector("#login-wrapper");
//     if (isOtpVisible) {
//       loginWrapper.classList.add("blur-background");
//     } else {
//       loginWrapper.classList.remove("blur-background");
//     }
//   }, [isOtpVisible]);

//   return (
//     <>
//       <div id="login-wrapper" className={isOtpVisible ? "blur-background" : ""}>
//         <div className="login-form">
//           <h2>Welcome Back</h2>
//           <form>
//             <div className="form-group">
//               <p>Username</p>
//               <i className="fa-regular fa-user fa-form-group-icon"></i>
//               <input
//                 type="text"
//                 name="username"
//                 value={loginData.username}
//                 placeholder="Enter Username"
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Password</label>
//               <i
//                 onClick={handleEye}
//                 id="eyeIcon"
//                 className="fa-solid fa-eye fa-eye-slash"
//               ></i>
//               <input
//                 type={passwordVisible ? "text" : "password"}
//                 name="password"
//                 value={loginData.password}
//                 placeholder="Enter Password"
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             <button type="submit" onClick={handleLogin} className="login-btn">
//               Login
//             </button>
//           </form>
//         </div>
//       </div>

//       {/* OTP Modal Popup */}
//       {isOtpVisible && (
//         <div className="otp-popup">
//           <div className="otp-container">
//             <h3>Enter OTP</h3>
//             <input
//               type="text"
//               name="otp"
//               value={otp}
//               onChange={handleOtpChange}
//               placeholder="Enter the OTP sent to your phone"
//               required
//             />
//             <button onClick={handleOtpVerification} className="verify-otp-btn">
//               Verify OTP
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Display success message after OTP verification */}
//       {isLoggedIn && (
//         <div className="success-message">
//           <p>Login successful! Welcome.</p>
//         </div>
//       )}
//     </>
//   );
// };

// export default Login;
























import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import "./Login.css";

const Login = () => {

  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [passwordVisible, setPasswordVisible] = useState(false);

  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
  });

  const [deviceId, setDeviceId] = useState("");

  const [loginId, setLoginId] = useState(null);
  const [otp, setOtp] = useState("");
  const [isOtpVisible, setIsOtpVisible] = useState(false);

  /* ================= DEVICE FINGERPRINT ================= */

  useEffect(() => {
    const loadFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setDeviceId(result.visitorId);
    };

    loadFingerprint();
  }, []);

  /* ================= HANDLE INPUT ================= */

  const handleChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const togglePassword = () => {
    setPasswordVisible(!passwordVisible);
  };

  /* ================= LOGIN ================= */

  const handleLogin = async (e) => {

    e.preventDefault();

    try {

      const response = await axios.post(
        `${API_BASE_URL}/admin/login`,
        {
          ...loginData,
          deviceId
        }
      );

      /* ================= SUBADMIN LOGIN ================= */

      if (response.data.token) {

        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", response.data.role);
        localStorage.setItem("services", JSON.stringify(response.data.services));

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + response.data.token;

        await Swal.fire({
          icon: "success",
          title: "Login Successful",
          text: "Welcome back!",
          timer: 1500,
          showConfirmButton: false,
        });

        if (response.data.role === "subAdmin") {
          navigate("/student-profile");
        } else {
          navigate("/");
        }
      }

      /* ================= ADMIN OTP ================= */

      else if (response.data.id) {

        setLoginId(response.data.id);
        setIsOtpVisible(true);

        Swal.fire({
          icon: "info",
          title: "OTP Sent",
          text: "Please check your registered mobile number.",
        });
      }

    } catch (error) {

      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: error.response?.data?.msg || "Something went wrong",
      });

    }

  };

  /* ================= OTP VERIFY ================= */

  const handleOtpVerification = async () => {

    try {

      const response = await axios.post(
        `${API_BASE_URL}/admin/verify-otp/${loginId}`,
        { otp, deviceId }
      );

      localStorage.setItem("token", response.data.token);
      localStorage.setItem("role", response.data.role);

      axios.defaults.headers.common["Authorization"] =
        "Bearer " + response.data.token;

      setIsOtpVisible(false);

      await Swal.fire({
        icon: "success",
        title: "OTP Verified",
        text: "Login Successful!",
        timer: 1500,
        showConfirmButton: false,
      });

      if (response.data.role === "subAdmin") {
        navigate("/student-profile");
      } else {
        navigate("/");
      }

    } catch (error) {

      Swal.fire({
        icon: "error",
        title: "Invalid OTP",
        text: error.response?.data?.msg || "OTP verification failed",
      });

    }

  };

  /* ================= BACKGROUND BLUR ================= */

  useEffect(() => {

    const wrapper = document.getElementById("login-wrapper");

    if (wrapper) {

      if (isOtpVisible) {
        wrapper.classList.add("blur-background");
      } else {
        wrapper.classList.remove("blur-background");
      }

    }

  }, [isOtpVisible]);

  return (
    <>
      <div id="login-wrapper">
        <div className="login-form">

          <h2>Admin Login</h2>

          <form onSubmit={handleLogin}>

            <div className="form-group">
              <label>Username</label>
              <input
                type="text"
                name="username"
                value={loginData.username}
                placeholder="Enter Username"
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group password-group">

              <label>Password</label>

              <input
                type={passwordVisible ? "text" : "password"}
                name="password"
                value={loginData.password}
                placeholder="Enter Password"
                onChange={handleChange}
                required
              />

              <i
                onClick={togglePassword}
                className={`fa-solid ${
                  passwordVisible ? "fa-eye-slash" : "fa-eye"
                } eye-icon`}
              ></i>

            </div>

            <button type="submit" className="login-btn">
              Login
            </button>

          </form>

        </div>
      </div>

      {/* ================= OTP MODAL ================= */}

      {isOtpVisible && (

        <div className="otp-popup">

          <div className="otp-container">

            <h3>Enter OTP</h3>

            <input
              type="text"
              value={otp}
              onChange={handleOtpChange}
              placeholder="Enter OTP"
              required
            />

            <button onClick={handleOtpVerification}>
              Verify OTP
            </button>

          </div>

        </div>

      )}

    </>
  );
};

export default Login;